import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Button, Form, Modal, Nav } from "react-bootstrap";
import { FaRegSquarePlus } from "react-icons/fa6";
import * as yup from "yup";
import { Formik, useFormik } from "formik";
import toast from "react-hot-toast";
import moment from "moment";
import { BiSolidEditAlt } from "react-icons/bi";
import CustomisedModal from "../../components/Modal/CustomisedModal";
import { MdDelete } from "react-icons/md";
import { IoMdArrowBack } from "react-icons/io";
import CreatePromoCodes from "./CreatePromoCodes";
import filtericon from "../../assets/images/Filter.png";
import { Box, Paper, Tooltip } from "@mui/material";
import DataTable from "react-data-table-component";
import deleteIcon from "../../assets/images/delete.png";
import editIcon from "../../assets/images/edit.png";
import {
  createPromoCodes,
  deletePromoCode,
  editPromoCodes,
  getActivePromocodesCount,
  getActivePromocodesListing,
  getInActivePromocodesCount,
  getInActivePromocodesListing,
  getPromocodesListing,
  statusPromoCodeUpdate,
  getOfferListing,
  approvePromocode,
  statusPromoUpdate
} from "../../api/context/promocodes";
import { getSubCategoryListing } from "../../api/context/subcategory";
import {
  getCategoryListing,

} from "../../api/context/category";
import Loader from "../../components/loader/loader";
import { checkUserPermissions } from "../../helpers/permission";
import { getInventoryListingPaginate } from "../../api/context/products";
import imageToBase64 from 'image-to-base64/browser';
import { getStoresListing } from "../../api/context/manufacturer";
import defaultlogo from '../../assets/svg/logo-dashboard-v1.png';


const queueDatatableCustomStyles = {
  headCells: {
    style: {
      display: "flex",
      justifyContent: "center",
      fontWeight: '600',
      fontSize: '14px',

    },
  },
  cells: {
    style: {
      display: "flex",
      justifyContent: "center",
      fontSize: '12px',
      fontWeight: '500',
      padding: '12px',
    },
  },

};

const PromoCodes = () => {


  const [show, setShow] = useState(false);
  const [showimg, setShowImg] = useState(false);
  const [promoimg, setPromoImg] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [totalActiveRows, setTotalActiveRows] = useState(0);
  const [totalInActiveRows, setTotalInActiveRows] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [limitactive, setLimitActive] = useState(10);
  const [pageactive, setPageActive] = useState(1);
  const [limitinactive, setLimitInactive] = useState(10);
  const [pageinactive, setPageInactive] = useState(1);
  const [update, setUpdate] = useState(false);
  const [selectedpromocode, setSelectedPromocode] = useState(null);
  const [category, setCategory] = useState([]);
  const [subcategory, setSubCategory] = useState([]);
  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);
  const [activedata, setActiveData] = useState([]);
  const [inactivedata, setInActiveData] = useState([]);
  const [activecount, setActiveCount] = useState([]);
  const [inactivecount, setInActiveCount] = useState([]);
  const [loading, setLoading] = useState(false);
  const [initial, setInitial] = useState(false);
  const [filter, setFilter] = useState("all");
  const [currentActiveMonth, setCurrentActiveMonth] = useState("");
  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth() + 1);
  const [currentInactiveMonth, setCurrentInactiveMonth] = useState("");
  const [inventory, setInventory] = useState([]);
  const [offer, setOffer] = useState([]);
  const [changeNumber, setNumberChange] = useState("")
  const [numberState, setNumberState] = useState(false)
  const [values, setValues] = useState()
  const [selected, setSelected] = useState([])
  const [color, setColor] = useState("")
  const [store, setStore] = useState([]);
  const [capitalState, setCapitalState] = useState()
  const [preImage, setPreImage] = useState()
  const [approved, setApproved] = useState()

  const monthOptions = [
    { id: 1, name: "Jan" },
    { id: 2, name: "Feb" },
    { id: 3, name: "Mar" },
    { id: 4, name: "Apr" },
    { id: 5, name: "May" },
    { id: 6, name: "Jun" },
    { id: 7, name: "Jul" },
    { id: 8, name: "Aug" },
    { id: 9, name: "Sep" },
    { id: 10, name: "Oct" },
    { id: 11, name: "Nov" },
    { id: 12, name: "Dec" },
  ];

  const handleShow = () => setShow(true);

  const handleShowImage = (promoimage) => {
    setShowImg(true);
    setPromoImg(promoimage)
  }

  // Inside your component
  const [modal, setModal] = useState(false);
  const [deletingId, setDeletingId] = useState("");

  const toggleModal = () => {
    setModal(!modal);
  };
  const user = JSON.parse(localStorage.getItem('user'));
  console.log(user);
  const handleClose = () => {
    if (user?.userType === "Vendor") {

      formik.setValues(

        {
          ...formik.values,
          name: "",
          code: "",
          description: "",
          offerType: "Buy and Get Free",
          selectedBuyProduct: "",
          buy_n: "",
          get_n: "",
          // bogoProductIds: [],
          selectedGetProduct: "",
          // vendors:[] ,

          categories: [],
          // selectedVendors: [],
          minimum_cart_value: "",
          amount: "",
          category_ids: [],
          // freeItems: [],
          sub_category_ids: [],
          image: "",
          expiryDate: "",
          // usageLimit: "",
          // selectedVendors: [], 
          selectedInventory: "",
          selectedSubCategory: []
        })
    } else {
      formik.resetForm();
    }
    setShow(false);
    setSelectedPromocode(null);
  };

  const handleCloseImage = () => {
    setShowImg(false);
  }

  const columns = [
    {
      name: "S. No.",
      selector: (row, index) => {
        if (filter === "all") {
          return page * limit - limit + (index + 1);
        } else if (filter === "active") {
          return pageactive * limitactive - limitactive + (index + 1);
        } else if (filter === "inactive") {
          return pageinactive * limitinactive - limitinactive + (index + 1);
        } else {
          // Handle other cases or fallback to default logic
          return page * limit - limit + (index + 1);
        }
      },
      width: "90px",
    },
    {
      id: "image",
      name: "Image",
      selector: (row) => row?.image,
      cell: (row) => (
        <div className="promocode_img_wrapper" onClick={() => handleShowImage(row?.image ? row?.image : defaultlogo)}>
          <img src={row?.image ? row?.image : defaultlogo} alt={row?.name} className="img-fluid" />
        </div>
        // <Tooltip title={row?.image} disableInteractive placement="top">
        //   <div className="text-truncate">{row?.image}</div>
        // </Tooltip>
      ),
      width: "120px",
    },
    {
      id: "name",
      name: "Name",
      selector: (row) => row?.name,
      cell: (row) => (
        <Tooltip title={row?.name} disableInteractive placement="top">
          <div className="text-truncate">{row?.name}</div>
        </Tooltip>
      ),
      width: "150px",
    },
    {
      id: "code",
      name: "Code",
      selector: (row) => row?.code,
      cell: (row) => (
        <Tooltip title={row?.code} disableInteractive placement="top">
          <div className="text-truncate">{row?.code}</div>
        </Tooltip>
      ),
      width: "120px",
    },
    {
      id: "OfferType",
      name: "Offer Type",
      selector: (row) => row?.offerType,
      cell: (row) => (
        <Tooltip title={row?.offerType} disableInteractive placement="top">
          <div className="text-truncate">{row?.offerType}</div>
        </Tooltip>
      ),
      width: "250px",
    },
    {
      id: "createdby",
      name: "Created By",
      selector: (row) => row?.Manufacturer?.storeName,
      cell: (row) => (
        <Tooltip title={row?.Manufacturer?.storeName} disableInteractive placement="top">
          <div className="text-truncate">{row?.Manufacturer?.storeName}</div>
        </Tooltip>
      ),
      width: "150px",
    },
    {
      id: "address",
      name: "Address",
      selector: (row) => row?.Manufacturer?.address,
      cell: (row) => (
        <Tooltip title={`${row?.Manufacturer?.address}, ${row?.Manufacturer?.city}, ${row?.Manufacturer?.state}`} disableInteractive placement="top">
          <div className="text-truncate">{row?.Manufacturer?.address}, {row?.Manufacturer?.city}, {row?.Manufacturer?.state}</div>
        </Tooltip>
      ),
      width: "150px",
    },
    {
      id: "phonenumber",
      name: "Phone Number",
      selector: (row) => row?.Manufacturer?.phoneNumber,
      cell: (row) => (
        <Tooltip title={row?.Manufacturer?.phoneNumber} disableInteractive placement="top">
          <div className="text-truncate">{row?.Manufacturer?.phoneNumber}</div>
        </Tooltip>
      ),
      width: "150px",
    },

    {
      name: "Approval Status",
      selector: (row) => row.approved
      ,
      cell: (row) => (
        <div className="status_wrap_btn">
          {row.approved === true ? (

            <div className="active_btn">Approved</div>
          ) : (
            <div className="in_active_btn">Pending</div>
          )}
        </div>
      ),
      sortable: true,
      center: true,
      width: "190px",
    },

    {
      name: "Status",
      selector: (row) => row.status,
      cell: (row) => (
        <div className="status_wrap_datatable">
          <Form.Check
            role="button"
            type="switch"
            id="custom-switch"
            checked={row.isActive === true}
            onChange={() => statusActive(row?.id)}
          />
        </div>
      ),
      sortable: true,
      center: true,
      width: "150px",
    },

    {
      name: "Status",
      selector: (row) => row.status
      ,
      cell: (row) => (
        <div className="status_wrap_btn">
          {row.isActive === true ? (
            <div className="active_btn">Active</div>
          ) : (
            <div className="in_active_btn">Inactive</div>
          )}
        </div>
      ),
      sortable: true,
      center: true,
      width: "150px",
    },

    {
      id: "action",
      name: "Action",
      cell: (row) => (
        <div>
          {checkUserPermissions("manage_promocodes") ? (
            <div className="d-flex align-items-center">
              <div className="d-flex flex-row gap-3" role="button">
                <Tooltip title="Edit" disableInteractive placement="top">
                  <div className="edit_icon_bg" onClick={() => handleEditClick(row)}>
                    <img
                      src={editIcon}
                      alt="Edit"
                      className="edit_icon"
                    />
                  </div>
                </Tooltip>
                <Tooltip title="Delete" disableInteractive placement="top">
                  <div className="delete_icon_bg" onClick={() => handleConfirm(row?.id)}>
                    <img
                      src={deleteIcon}
                      alt="Delete"
                      className="delete_icon"
                    />
                  </div>
                </Tooltip>
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      ),
      center: true,
      width: "150px",
    },
  ];

  // const data = [
  //     {
  //         code: 'NEW10',
  //         discount: 'Percentage (10%)',
  //         expirydate: '8/16/13',
  //         uselimit: '3',
  //     },
  //     {
  //         code: 'SHOP500',
  //         discount: 'Amount (Rs.100)',
  //         expirydate: '5/7/16',
  //         uselimit: '1',
  //     },
  //     {
  //         code: 'GET25',
  //         discount: 'Free Shipping',
  //         expirydate: '9/18/16',
  //         uselimit: '3',
  //     },
  //     {
  //         code: 'KIDS15',
  //         discount: 'Percentage (15%)',
  //         expirydate: '9/4/12',
  //         uselimit: '2',
  //     },
  //     {
  //         code: 'FIRST20',
  //         discount: 'Buy 1, Get 1',
  //         expirydate: '6/19/14',
  //         uselimit: '1',
  //     },
  //     {
  //         code: 'NEW10',
  //         discount: 'Free Shipping',
  //         expirydate: '6/19/14',
  //         uselimit: '1',
  //     },
  // ]


  // const getAmountValidationSchema = (offerType) => {
  //   console.log(offerType);
  //   if (
  //     offerType === "Flat Amount on Minimum Cart Value" ||
  //     offerType === "Discount in Percentage on Minimum Cart Value" ||
  //     offerType === "Flat Amount on Category or Subcategory" ||
  //     offerType === "Discount in Percentage on Category or Subcategory"
  //   ) {
  //     return yup.string().trim().required("Amount is required");
  //   } else {
  //     return yup.string().trim().default('');
  //   }
  // };

  // const validationSchema = yup.object().shape({
  // //   vendor_id:yup.string("").trim().required("Vendor  is required"),
  // //   name:yup.string("").trim().required("Name  is required"),
  // //   code: yup.string("").trim().required("Code  is required"),
  // //   description:yup.string("").trim().required("Description is required"),
  // // subcategoryId:  yup
  // // .string()
  // // .when(['offerType'], {
  // //   is: (offerType) => offerType === "Flat Amount on Category or Subcategory" && "Discount in Percentage on Category or Subcategory",
  // //   then: yup.string().trim().required("Amount is required"),
  // // }),
  // // amount: yup.string().when(['offerType'], {
  // //   is: offerType => true,
  // //   then: (offerType) => getAmountValidationSchema(offerType),
  // //   otherwise: yup.string().trim().default('')
  // // }),
  // // amount: yup
  // // .string()
  // // .when(['offerType'], {
  // //   is: (offerType) => offerType === "Buy and Get Free'",
  // //   then: yup.string().trim().required("Amount is required"),
  // // }),    


  //             get_n:yup.string()
  // .when(['offerType'], {
  //   is: (offerType) => offerType === "Buy and Get Free'",
  //   then: yup.string().trim().required("Amount is required"),
  // }),

  //  minimum_cart_value:yup.string()
  //  .when(['offerType'], {
  //    is: (offerType) => offerType === "Flat Amount on Minimum Cart Value" || "Discount in Percentage on Minimum Cart Value" && "Free Item on Minimum Cart Value",
  //    then: yup.string().trim().required("Amount is required"),
  //  }),
  //  expiryDate: yup.string("").trim().required("Expiry Date is required"),
  //  usageLimit: yup.string("").trim().required("Usage Limit is required"),
  //  buy_n:yup.string("").required("Quantity required"),
  //  get_n:yup.string("").required("Quantity required"),
  // discount: yup.string("").trim().required("Discount is required"),

  // });
  // vendor_id:yup.string("").trim().required("Vendor  is required"),
  // name:yup.string("").trim().required("Name  is required"),
  // code: yup.string("").trim().required("Code  is required"),
  // description:yup.string("").trim().required("Description is required"),
  // discount: yup.string("").trim().required("Discount is required"),
  // subcategoryId: yup.string("").trim().required("Category Id is required"),
  // buy_n:yup.string("").required("Quantity required"),
  // get_n:yup.string("").required("Quantity required"),
  // minimum_cart_value:yup.string("").trim().required("Minimum Cart Value  is required"),
  // subSubcategoryId: yup
  //   .string("")
  //   .trim()
  //   .required("Sub Category Id is required"),
  // expiryDate: yup.string("").trim().required("Expiry Date is required"),
  // usageLimit: yup.string("").trim().required("Usage Limit is required"),
  // const validationSchema = yup.object().shape({
  //   expiryDate: yup.date().required("Date is required").min(new Date(), "Selected date must be in the future"),
  // });

  const validationSchema = yup.object().shape({
    image: selectedpromocode?.id ? yup.string().nullable() : yup
      .string('')
      .trim()
      .required('Image is required'),
    // desc: yup
    //     .string('')
    //     .trim()
    //     .required('Description is required'),
    // isActive: yup
    //     .boolean()
    //     .required('isActive is required'),
  });



  const formik = useFormik({
    initialValues: {
      name: "",
      code: "",
      description: "",
      offerType: "Buy and Get Free",
      selectedBuyProduct: "",
      buy_n: "",
      get_n: "",
      // bogoProductIds: [],
      selectedGetProduct: "",
      vendors: []
      ,
      categories: [],
      selectedVendors: [],
      minimum_cart_value: "",
      amount: "",
      category_ids: [],
      freeItems: [],
      sub_category_ids: [],
      image: "",
      expiryDate: "",
      // usageLimit: "",
      // selectedVendors: [], 
      selectedInventory: "",
      selectedSubCategory: []

    },
    validationSchema: validationSchema,
    validate: async (values) => {
      const errors = {}

      if (!values.name) {
        errors.name = "Code Name is required"
      }
      if (!values.description) {
        errors.description = "Description required"
      }
      if (!values.code) {
        errors.code = "Code required"
      }


      if (values.offerType !== "Flat Amount on Category or Subcategory" && values.offerType !== "Discount in Percentage on Category or Subcategory") {
        if (values.selectedVendors.length === 0) {
          errors.selectedVendors = "Vendor is required";
        }
      }


      if (!values.expiryDate) {
        errors.expiryDate = "Expiry date is required"
      }

      //   if (!values.name) {
      //     errors.name = "Vendor is required"
      //   }
      //   if (!values.description) { 
      //     errors.description = "Description required"
      //   }
      //   if (!values.code) {
      //     errors.code = "Code required"
      //   }
      //   // if (user?.userType === "Admin") {
      //     if (!values.vendor_id) {
      //         errors.vendor_id = "Vendor is required";
      //     }
      // // }F

      //   if(!values.expiryDate){       
      //     errors.expiryDate="Expiry date is required"
      //   }

      // if(!values.image){
      //   errors.image="Image required"
      // }

      // if(!values.img_view){
      //   errors.image="Image required"
      // }


      if (values.offerType === "Buy and Get Free") {
        // Validation for Buy and Get Free offer type
        if (!values.selectedGetProduct) {
          errors.selectedGetProduct = "Get product is required";
        }
        if (!values.selectedBuyProduct) {
          errors.selectedBuyProduct = "Product is required";
        }
        if (!values.buy_n) {
          errors.buy_n = "Quantity required";
        }
        if (isNaN(values.buy_n)) {
          errors.buy_n = "Type Number"
        }
        if (!values.get_n) {
          errors.get_n = "Quantity required";
        }
        if (isNaN(values.get_n)) {
          errors.get_n = "Type Number"
        }

      }
      else if (values.offerType === "Flat Amount on Minimum Cart Value" || values.offerType === "Discount in Percentage on Minimum Cart Value") {
        // Validation for Flat Amount or Discount on Minimum Cart Value offer types
        if (!values.minimum_cart_value) {
          errors.minimum_cart_value = "Enter minimum cart value";
        }
        if (isNaN(values.minimum_cart_value)) {
          errors.minimum_cart_value = "Type Number"
        }
        if (!values.amount) {
          errors.amount = "Enter amount";
        }
        if (isNaN(values.amount)) {
          errors.amount = "Type Number"
        }
      }
      else if (values.offerType === "Flat Amount on Category or Subcategory" || values.offerType === "Discount in Percentage on Category or Subcategory") {
        // Validation for Flat Amount or Discount on Category or Subcategory offer types
        if (!values.amount) {
          errors.amount = "Amount required";
        }
        if (isNaN(values.amount)) {
          errors.amount = "Type Number"
        }
        if (!values.category_ids.length > 0) {
          errors.category_ids = "Category is required";
        }
        if (!values.sub_category_ids.length > 0) {
          errors.sub_category_ids = "Sub Category is required";
        }
      }

      else if (values.offerType === "Free Item on Minimum Cart Value") {
        // Validation for Free Item on Minimum Cart Value offer type
        if (!values.minimum_cart_value) {
          errors.minimum_cart_value = "Minimum cart value required";
        }
        if (isNaN(values.minimum_cart_value)) {
          errors.minimum_cart_value = "Type Number"
        }
        if (!values.selectedInventory) {
          errors.selectedInventory = "Product required";
        }
      }

      return errors
    },
    onSubmit: (values, { resetForm }) => {

      if (values.img == '') {
        delete values.img;
      }
      delete values.img_view;

      if (!values.expiryDate) {

      }

      setLoading(true);




      if (selectedpromocode?.id) {
        editPromoCodes(values)((response) => {
          if (response && response?.data?.statusCode == 200) {
            resetForm();
            toast.success("Promo Code Updated Successfully");
            handleClose();

            setUpdate(!update);
            setSelectedPromocode(null);
            setLoading(true);
          } else {
            toast.error(response?.data?.message);
            setLoading(false);
          }
        });
      } else {

        createPromoCodes(values)((response) => {
          if (response && response?.data?.statusCode == 200) {
            resetForm();
            toast.success("Promo Code Created Successfully");

            handleClose();
            setUpdate(!update);
            setSelectedPromocode(null);
            setLoading(false);
          } else {
            toast.error(response?.data?.message);
            setLoading(false);
          }
        });
      }
    },
  });


  // console.log((containsOnlyLettersAndNumbers(formik.values.code)));
  const handleImageChange = async (e) => {

    const file = e?.target?.files[0];
    const maxSizeInBytes = 2 * 1024 * 1024;
    const validImageTypes = ['image/jpeg', 'image/png', 'image/gif'];


    if (file?.size > maxSizeInBytes) {
      toast.error("File size exceeds 2 MB limit", 'error')
      e.target.value = null;
      return;
    }

    if (!validImageTypes.includes(file?.type)) {
      toast.error("Only jpg/jpeg and png files are allowed!");
      e.target.value = null;
      return;
    }

    const response = await imageToBase64(URL.createObjectURL(file));
    formik.setValues({
      ...formik.values,
      image: response,
      img_view: 'data:image/jpeg;base64,' + response,
    });
  }
  console.log(values);
  const fetchPromoCodesData = async () => {
    getPromocodesListing({ page: page, pageSize: limit, search })((response) => {
      if (response?.statusCode === 200) {
        console.log(response);
        setData(response.offers);
        setApproved(data.map((li) => li.approved))
        setTotalRows(response?.totalItems);
        setLoading(false);
      } else {
        setData([]);
        setLoading(false);
      }
    }
    );
  };
  console.log(data);
  const getStoresDetails = () => {
    getStoresListing()((response) => {
      if (response?.statusCode === 200) {
        setStore(response?.data?.[0]);
        if (user?.userType === "Vendor") {
          // formik.setFieldValue('vendor_id', response?.data?.[0]?.id)
          const vendorList = [...formik.values.vendors]
          const freeItemList = [...formik.values.freeItems]

          vendorList.push({
            vendorId: response?.data?.[0]?.id,
            vendorLabel: response?.data?.[0]?.ownerName,
            buy_quantity: "",
            get_quantity: "",
            items: [{
              selectedBuyProduct: "",
              selectedGetProduct: "",
              get_product: "",
              buy_product: ""
            }]
          })
          freeItemList.push(
            {

              vendorId: response?.data?.[0]?.id,
              vendorLabel: response?.data?.[0]?.ownerName,
              minimum_cart_value: "",
              product_id: "",
              selectedProduct: ""

            }
          )
          formik.setValues({
            ...formik.values,
            vendors: vendorList,
            selectedVendors: [{ value: response?.data?.[0]?.id, label: response?.data?.[0]?.ownerName }],
            freeItems: freeItemList,
            vendorIds: response?.data?.[0]?.id


          })
        }
      } else {
      }
    });
  };

  console.log(store, 'store details');

  const fetchActivePromoCodesData = async () => {
    getActivePromocodesListing({ page: pageactive, pageSize: limitactive })(
      (response) => {
        if (response?.statusCode === 200) {
          setActiveData(response.offers);
          setTotalActiveRows(response?.totalItems);
          setLoading(false);
        } else {
          setActiveData([]);
          setLoading(false);
        }
      }
    );
  };

  const fetchInActivePromoCodesData = async () => {
    getInActivePromocodesListing({
      page: pageinactive,
      pageSize: limitinactive,
    })((response) => {
      if (response?.statusCode === 200) {
        setInActiveData(response.offers);
        setTotalInActiveRows(response?.totalItems);
        setLoading(false);
      } else {
        setInActiveData([]);
        setLoading(false);
      }
    });
  };

  const fetchActivePromoCodesCount = async (id) => {
    getActivePromocodesCount({ month: id })((response) => {
      if (response?.statusCode === 200) {
        setActiveCount(response?.data);
        setLoading(false);
      } else {
        setActiveCount([]);
        setLoading(false);
      }
    });
  };

  const fetchInActivePromoCodesCount = async (id) => {
    getInActivePromocodesCount({ month: id })((response) => {
      if (response?.statusCode === 200) {
        setInActiveCount(response?.data);
        setLoading(false);
      } else {
        setInActiveCount([]);
        setLoading(false);
      }
    });
  };


  const fetchManufactureDetails = async () => {
    getStoresListing()
  }

  const handleActiveMonthChange = (selectedMonthId) => {
    const monthId = parseInt(selectedMonthId);
    setCurrentActiveMonth(monthId);
    fetchActivePromoCodesCount(monthId);
  };

  const availableMonths = monthOptions.filter(month => month.id <= currentMonth);

  const handleInActiveMonthChange = (selectedMonthId) => {
    const monthId = parseInt(selectedMonthId);
    setCurrentInactiveMonth(monthId);
    fetchInActivePromoCodesCount(monthId);
  };


  // const getAllCategories = () => {
  //   getCategoryListing()((response) => {
  //     if (response?.statusCode == 200) {
  //       setCategory(response?.data?.subcategories);
  //     } else {
  //     }
  //   });
  // };

  const getAllOffer = () => {
    getOfferListing()((response) => {
      if (response?.statusCode == 200) {
        setOffer(response?.datas);
      } else {
      }
    });
  };
  console.log(offer);
  const handleConfirm = (deletingId) => {
    setModal(!modal);
    setDeletingId(deletingId);
  };

  const deletePromoCodes = (id) => {
    deletePromoCode(id)((response) => {
      if (response?.request?.status == 200) {
        setUpdate(!update);
        setModal(!modal);
        toast.success("Promocode deleted successfully")
      } else {
      }
    });
    // });
  };

  const statusActive = (id) => {
    statusPromoUpdate(id)((response) => {
      if (response?.data?.statusCode == 200) {
        setUpdate(!update);
      } else {
      }
    });
  };

  const handleEditClick = (promocode) => {
    console.log(promocode, "promocode edit");
    // const productLabel =promocode?.BogoProducts[0].bogoProduct.productName
    // const productValue= promocode?.bogoProduct[0].bogoProduct.id
    // const buyLabel = promocode.product.productName
    // const buyValue = promocode.product.id

    // console.log(productLabel);
    // console.log(productValue);

    const excludedVendorsData = promocode.excludedVendors?.map(vendor => ({
      value: vendor.id,
      label: vendor.storeName
    })) || [];

    setSelectedPromocode(promocode);

    formik.setValues({
      ...formik.values,
      offerType: promocode.offerType,
      name: promocode.name,
      code: promocode.code,
      category_id: String(promocode?.category_id ?? ""),
      sub_category_id: String(promocode?.sub_category_id ?? ""),
      description: promocode?.description ?? "",
      buy_n: promocode?.buy_n ?? "",
      get_n: promocode?.get_n ?? "",
      amount: promocode?.amount ?? "",
      selectedVendors: [{
        value: promocode.Manufacturer?.id,
        label: promocode.Manufacturer?.storeName
      }],
      // vendor_id: promocode.vendor_id,

      excludeVendorIds: promocode.excludedVendorIds || [],
      selectedExcludeVendors: excludedVendorsData,

      selectedGetProduct: promocode.BogoProducts?.map((li) => (
        // value: promocode?.BogoProducts[0]?.bogoProduct.id ? promocode?.BogoProducts[0]?.bogoProduct.id : '',
        // label: promocode?.BogoProducts[0]?.bogoProduct.productName ? promocode?.BogoProducts[0]?.bogoProduct.productName : ''
        {
          value: [li.bogoProduct?.id] ? [li.bogoProduct?.id] : [],
          label: li.bogoProduct?.productName ? li.bogoProduct?.productName : ""
        }
      )),
      selectedBuyProduct: promocode.BogoProducts?.map((li) => ({
        label: li?.buyProduct?.productName, value: li?.buyProduct?.id,
      })),
      product_id: promocode.Product?.id ? promocode.Product?.id : "",
      bogoProductIds: [promocode?.BogoProducts[0]?.bogoProduct.id] ? [promocode?.BogoProducts[0]?.bogoProduct.id] : [],
      minimum_cart_value: promocode?.minimum_cart
        ?? "",
      expiryDate: promocode?.expiryDate
        ?? "",
      usageLimit: promocode?.usageLimit ?? "",
      freeDelivery: promocode?.freeDelivery ?? "",
      // image:promocode.image,
      offerId: promocode.id,
      selectedInventory: {
        value: promocode.Product?.id ? promocode.Product?.id : "",
        label: promocode.Product?.productName ? promocode.Product?.productName : "",
      },

      vendor_id: promocode.Manufacturer?.id,
      img_view: promocode?.image ?? '',
      category_ids: [promocode.Subcategory?.id],
      sub_category_ids: [promocode.SubSubcategory?.id],
      selectedSubCategory: [
        { value: promocode.SubSubcategory?.id, label: promocode.SubSubcategory?.title }
      ],
      selectedCategory: promocode.Subcategory ? [{ value: promocode.Subcategory?.id, label: promocode.Subcategory?.title }] : [],
      categories: [{
        categoryId: promocode.Subcategory?.id,
        categoryLabel: promocode.Subcategory?.title,
        subcategories: [promocode.SubSubcategory?.id
        ],
        selectedSubSubCategories: [{
          value: promocode.SubSubcategory?.id, label: promocode.SubSubcategory?.title
        }]

      }],
      freeItems: [
        {
          vendorId: promocode.Manufacturer?.id,
          vendorLabel: promocode.Manufacturer?.storeName,
          minimum_cart_value: promocode.minimum_cart,
          product_id: promocode.Product?.id ? promocode.Product?.id : "",
          selectedProduct: {
            value: promocode.Product?.id ? promocode.Product?.id : "",
            label: promocode.Product?.productName ? promocode.Product?.productName : "",
          }
        }
      ],
      vendors: [{
        vendorLabel: promocode.Manufacturer?.storeName,
        vendorId: promocode.Manufacturer?.id,
        buy_quantity: promocode.buy_n,
        get_quantity: promocode.get_n,
        amount: promocode.amount,
        minimum_cart_value: promocode.minimum_cart,
        // items:[{
        //   // selectedBuyProduct: {label:},
        //   selectedGetProduct: [],
        //   get_product: [],
        //   buy_product:promocode.BogoProducts.map((li)=>{return{label:li?.buyProduct?.productName,value:li?.buyProduct?.id}})
        //   // selectedBuyProduct:{value:promocode.BogoProducts.buyProduct.id,label:promocode.BogoProducts.buyProduct.productName}
        // }]
        items: promocode.BogoProducts.map((li) => {
          return {
            // label:li?.buyProduct?.productName,
            // value:li?.buyProduct?.id}
            // selectedBuyProduct: {label:},

            selectedBuyProduct: { label: li?.buyProduct?.productName, value: li?.buyProduct?.id },
            selectedGetProduct: { label: li?.bogoProduct?.productName, value: li?.bogoProduct?.id },
            get_product: li?.bogoProduct?.id,
            buy_product: li?.buyProduct?.id,
          }
        })
      }]

      // image: promocode?.image ?? ''
    });
    setPreImage(promocode.image)
    setShow(true);
  };
  console.log(formik.values.selectedGetProduct);
  // console.log(formik.values.vendor_id);
  console.log(formik.values.selectedBuyProduct);
  // console.log(promocode?.BogoProducts[0]?.bogoProduct.id);
  const handlePerRowsChange = (newPerPage, page) => {
    setLimit(newPerPage);
    setPage(1);
    setUpdate(!update);
  };

  const handlePerRowsActiveChange = (newPerPage, page) => {
    setLimitActive(newPerPage);
    setPageActive(1);
    setUpdate(!update);
  };

  const handlePerRowsInactiveChange = (newPerPage, page) => {
    setLimitInactive(newPerPage);
    setPageInactive(1);
    setUpdate(!update);
  };

  const handlePageChange = (page) => {
    setPage(page);
    setUpdate(!update);
  };

  const handlePageActiveChange = (page) => {
    setPageActive(page);
    setUpdate(!update);
  };

  const handlePageInactiveChange = (page) => {
    setPageInactive(page);
    setUpdate(!update);
  };

  const handleFilterChange = (filter) => {
    console.log(filter);
    setFilter(filter);
  };

  let typingTimer;
  const loadOptionsInventory = (inputValue) => {

    return new Promise((resolve, reject) => {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(() => {
        if (inputValue.length >= 3) {
          console.log(inputValue);

          getInventoryListingPaginate({
            page: 1,
            limit: 10,
            search: inputValue,
            vendor_id: formik.values.vendor_id
          })((response) => {
            if (response?.statusCode == 200) {
              console.log(response?.results);
              resolve(response?.results);
              setInventory(response?.results);
            } else {
            }
          });
        } else {
          resolve([]);
        }
      }, 300);
    });
  };
  console.log(formik.values.vendor_id);



  const onInventoryChange = (selectedOption) => {
    console.log(selectedOption);
    const productValues = selectedOption.map((li) => (
      { productId: li.value, vendorId: li.vendorId }
    ))
    console.log(productValues);
    formik.setValues({
      ...formik.values,
      product_id: selectedOption ? productValues : "",
      selectedInventory: selectedOption,
    });
  };


  const onBuyProduct = (selectedOption, index, itemIndex) => {
    console.log(selectedOption, "===========");
    // const productValues=selectedOption.map((li)=>(
    //   {product_id:li.value}
    // ))

    const itemData = [...formik.values.vendors]
    // const productValue = {...itemData}
    // const items ={...productValue,items:{buy_product:productValues}}
    itemData[index].items[itemIndex].buy_product = selectedOption?.value ? selectedOption?.value : ""
    itemData[index].items[itemIndex].selectedBuyProduct = selectedOption ? selectedOption : ""


    formik.setValues({
      ...formik.values,
      product_id: selectedOption ? selectedOption : "",
      selectedBuyProduct: selectedOption ? selectedOption : '',
      vendors: itemData
    });
  };

  const onGetProduct = (selectedOption, index, itemIndex) => {
    console.log(selectedOption);
    // const productValues=selectedOption.map((li)=>(
    // li.value 
    // ))

    const itemData = [...formik.values.vendors]
    // const productValue = {...itemData}
    // const items ={...productValue,items:{get_product:productValues}}
    itemData[index].items[itemIndex].get_product = selectedOption?.value ? selectedOption?.value : ""
    itemData[index].items[itemIndex].selectedGetProduct = selectedOption ? selectedOption : ""
    // const itemsIndex=itemData[index]
    // const items = {...itemsIndex,items[index].get_product=}
    // itemData[index].slectedGetProduct


    formik.setValues({
      ...formik.values,
      vendors: itemData,
      bogoProductIds: selectedOption ? selectedOption.value : "",
      selectedGetProduct: selectedOption ? selectedOption : "",
    });
  };

  const onBuyQuantityChange = (value, index) => {
    console.log(value);
    const a = [...formik.values.vendors]
    a[index].buy_quantity = value

    // const items =[{get_product:formik.values.bogoProductIds,buy_product:formik.values.product_id}]
    // const productValue = {vendorId:formik.values.vendorIds,buy_quantity:value,get_quantity:formik.values.get_n, items  }
    const productValue = { ...formik.values.vendors, buy_quantity: value }
    formik.setValues({
      ...formik.values,
      vendors: a,
      buy_n: value,
      //  vendors:formik.values.vendors.map((li)=>li.vendorId===value)===true? formik.values.vendors.push(productValue):[]
      //  vendors:  productValue,  
    })
  }

  const onGetQuantityChange = (value, index) => {
    console.log(value);
    const a = [...formik.values.vendors]
    a[index].get_quantity = value
    // const items =[{get_product:formik.values.bogoProductIds,buy_product:formik.values.product_id}]
    // const productValue = {vendorId:formik.values.vendorIds,buy_quantity:value,get_quantity:formik.values.get_n, items  }
    const productValue = { ...formik.values.vendors, get_quantity: value }
    formik.setValues({
      ...formik.values,

      get_n: value,
      vendors: a,

    })
  }


  const onDateGet = (selectedDate) => {
    formik.setValues({
      ...formik.values,
      expiryDate: selectedDate
    })
  }
  const getNo = formik.values.get_n

  const handleSelectChange = ({ selectedRows }) => {
    console.log(selectedRows);
    const selectedVendorId = selectedRows.map((li) => li.id)

    setSelected(selectedVendorId)
  }

  const isRowSelected = (row) => {
    return row.approved === true
  }
  const isRowSelected1 = (row) => {
    return row.approved === false
  }

  console.log(selected, 'selected');

  const handleSelectHandler = (id, tabFilter) => {

    if (id.length === 0) {
      toast.error("Please select a promo code before approving");
      return;
    }

    approvePromocode(id)((response) => {
      console.log(response, "io");
      if (response?.status == 200) {
        toast.success("Promo code approved");
        setUpdate(!update);
        setFilter(null)
        setTimeout(() => {
          setFilter(tabFilter)
        }, 100)
      } else {
      }
    });

  }


  console.log(selected, "....");
  useEffect(() => {
    console.log("haiii");
    const buyNo = formik.values.buy_n
    const getNo = formik.values.get_n
    // console.log(buyNo,"...");
    // console.log(getNo,"++");
    if (getNo > buyNo) {
      console.log(getNo, "222");
      console.log(buyNo, "333");
      setNumberChange("Quantity can't be greater than Get quantity")
      setNumberState(true)
    } else {
      setNumberState(false)
    }
  }, [getNo])
  // console.log(...formik.initialValues.buy_n);


  useEffect(() => {
    const currentDate = new Date();
    const currentMonthId = currentDate.getMonth() + 1;
    setCurrentActiveMonth(currentMonthId);
    setCurrentInactiveMonth(currentMonthId);

    fetchActivePromoCodesCount(currentMonthId);
    fetchInActivePromoCodesCount(currentMonthId);
  }, []);

  useEffect(() => {
    setLoading(true);
    fetchPromoCodesData();
    fetchActivePromoCodesData();
    fetchInActivePromoCodesData();
    getAllOffer();
    // onManufactureChange()

    // fetchActivePromoCodesCount();
    // fetchInActivePromoCodesCount();
  }, [update]);

  //   useEffect(()=>{
  // onManufactureChange()
  //   },[formik.values.vendorIds,formik.values.get_n,formik.values.buy_n,formik.values.bogoProductIds,formik.values.product_id,])

  useEffect(() => {
    let timeout = setTimeout(() => {
      if (initial) setUpdate(!update);
      else setInitial(!initial);
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
  }, [search]);

  // useEffect(() => {
  //   if (formik?.values?.category_id) {
  //     getSubCategoryListing(formik?.values?.category_id)((response) => {
  //       if (response?.statusCode === 200) {
  //         setSubCategory(response?.data?.subSubCategory);
  //       } else {
  //       }
  //     });
  //   }
  // }, [formik?.values?.category_id]);

  useEffect(() => {
    if (formik?.values?.vendors) {
      getInventoryListingPaginate({ page: 1, limit: 10, search: "", vendorIds: formik.values.vendorIds })(
        (response) => {
          if (response?.statusCode == 200) {
            console.log(response);
            setInventory(response?.results);

            // setVendorId(formik.values.selectedVendors)

          } else {
          }
        }
      );
    }
  }, [formik?.values?.vendors]);


  useEffect(() => {
    // getAllCategories();
    getStoresDetails();
    // getInventoryListingPaginate({ page: 1, limit: 10, search: "",vendor_id:formik.values.vendor_id })(
    //   (response) => {
    //     if (response?.statusCode == 200) {
    //       console.log(response?.results);
    //       setInventory(response?.results);
    //     } else {
    //     }
    //   }
    // );
  }, []);

  // const handleSwitchChange=(e)=>{
  //   console.log(e.target.checked);
  // }
  //   useEffect(()=>{
  //     const items =[{get_product:formik.values.bogoProductIds,buy_product:formik.values.product_id}]
  // const productValue = {vendorId:formik.values.vendorIds,buy_quantity:formik.values.buy_n,get_quantity:formik.values.get_n, items  }
  // formik.setValues({
  //   ...formik.values,
  //   vendors: productValue ? productValue : [],
  //   selectedVendors: productValue,
  // })
  //   },[])

  console.log(formik, "");
  // console.log(numberState,"...");
  console.log(data.map((li) => li.approved));
  console.log(data);
  return (
    <>
      <div>
        <div className="row">
          <div className="col-12">
            <div className="page-header-sticky page-title-box d-sm-flex align-items-center justify-content-between">
              <h4 className="mb-sm-0">Promocodes</h4>
            </div>
          </div>
        </div>
        <div className="row">
          < div className="col-lg-6">
            <div className="active_promocodes">
              <div className="contents">
                <h5>Active promocodes</h5>
                <p>Represents Active Promocodes available recently.</p>
                <h6>{activecount}</h6>
              </div>
              <div className="month_fliter">
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Select
                    name="subCategoryId"
                    className="time_select"
                    onChange={(e) => handleActiveMonthChange(e.target.value)}
                    value={currentActiveMonth}
                  >
                    <option value="">Select</option>
                    {availableMonths.map((option) => (
                      <option key={option.id} value={option.id}>
                        {option.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="active_promocodes">
              <div className="contents">
                <h5>Inactive promocodes</h5>
                <p>Represents InActive Promocodes available recently.</p>
                <h6>{inactivecount}</h6>
              </div>
              <div className="month_fliter">
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Select
                    name="subCategoryId"
                    className="time_select"
                    onChange={(e) => handleInActiveMonthChange(e.target.value)}
                    value={currentInactiveMonth}
                  >
                    <option value="">Select</option>
                    {availableMonths.map((option) => (
                      <option key={option.id} value={option.id}>
                        {option.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div>
            </div>
          </div>
          <div className="col-12">
            <div className="request_wrapper_filter">
              <div className="filter_wrapper">
                <Nav variant="pills" defaultActiveKey="link-0">
                  <Nav.Item>
                    <Nav.Link
                      eventKey="link-0"
                      onClick={() => handleFilterChange("all")}
                    >
                      All
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      eventKey="link-1"
                      onClick={() => handleFilterChange("active")}
                    >
                      Active
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      eventKey="link-2"
                      onClick={() => handleFilterChange("inactive")}
                    >
                      Inactive
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </div>
              <div className="request_btn_wrapper">
                <div className="status_wrap_datatable">
                  {/* <Form.Check
            type="switch"
            id="custom-switch"
            // checked={row.isActive === true}
            // onChange={() => statusActive(row?.id)}
            onChange={()=>{handleSelectHandler(selected)}}
          /> */}
                  <div className="Promo_active_btn">
                    {user?.userType === "Vendor" ?
                      <></>
                      :
                      <Button
                        onClick={() => handleSelectHandler(selected, filter)}
                        // onChange={()=>{handleSelectHandler(selected)}}
                        className="active_btn">
                        Approve
                      </Button>
                    }


                  </div>
                </div>
                {/* <div className="filters">
                  <img
                    src={filtericon}
                    className="img-fluid filter_icon"
                    alt="Filter Icon"
                  />
                  <h5>Filters</h5>
                </div> */}
                {checkUserPermissions("manage_promocodes") ? (
                  <Button className="request_btn" onClick={handleShow}>
                    <FaRegSquarePlus className="icon" />
                    Add New
                  </Button>
                ) : (
                  <></>
                )}
              </div>
            </div>
            <div className="d_grid_wrapper"></div>
          </div>
          <CreatePromoCodes
            preImage={preImage}
            show={show}
            handleClose={handleClose}
            handleShow={handleShow}
            formik={formik}
            category={category}
            setCategory={setCategory}
            subcategory={subcategory}
            setSubCategory={setSubCategory}
            loading={loading}
            selectedpromocode={selectedpromocode}
            loadOptionsInventory={loadOptionsInventory}
            inventory={inventory}
            onBuyChange={onBuyProduct}
            onGetProduct={onGetProduct}
            onInventoryChange={onInventoryChange}
            offer={offer}
            onDate={onDateGet}
            handleImageChange={handleImageChange}
            onBuyQuantityChange={onBuyQuantityChange}
            onGetQuantityChange={onGetQuantityChange}
            // vendorDetails={vendorDetails}
            // onNumberChange={onHandleNumberChange}
            numberMistake={changeNumber}
            numberShow={numberState}
          // onManufactureChange={onManufactureChange}
          // number={changeNumber}
          />
          <CustomisedModal
            isOpen={modal}
            customClass={"policy_modal"}
            toggle={toggleModal}
          >
            <h5>Are you sure you want to remove this item?</h5>
            <div className="policy_Agree">
              <Button
                onClick={() => {
                  setModal(!modal);
                }}
                size="lg"
                className="btn_cancel"
              >
                Cancel
              </Button>
              <Button
                size="lg"
                className="btn"
                onClick={() => deletePromoCodes(deletingId)}
              >
                Delete
              </Button>
            </div>
          </CustomisedModal>
          {filter == "all" && (
            <Box className="products-and-options" sx={{ mt: 1 }}>
              <Paper square>
                <div>

                  <DataTable
                    columns={columns}
                    data={data}
                    progressPending={loading}
                    progressComponent={
                      <div style={{ height: "60vh" }}>
                        <Loader />
                      </div>
                    }
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationPerPage={limit}
                    onChangeRowsPerPage={handlePerRowsChange}
                    onChangePage={handlePageChange}
                    currentPage={page}
                    customStyles={queueDatatableCustomStyles}
                    selectableRows
                    // selectableRowsNoSelectAll
                    // selectableRowSelected={isRowSelected1}
                    selectableRowDisabled={isRowSelected}

                    onSelectedRowsChange={handleSelectChange}
                  />
                  {/* :
                  <DataTable
                    columns={columns}
                    data={data}
                    progressPending={loading}
                    progressComponent={
                      <div style={{ height: "60vh" }}>
                        <Loader />
                      </div>
                    }
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationPerPage={limit}
                    onChangeRowsPerPage={handlePerRowsChange}
                    onChangePage={handlePageChange}
                    currentPage={page}
                    customStyles={queueDatatableCustomStyles}
                    // selectableRows
                    // onSelectedRowsChange={handleSelectChange}
                  />

} */}
                </div>

              </Paper>
            </Box>
          )}
          {filter == "active" && (
            <Box className="products-and-options" sx={{ mt: 1 }}>
              <Paper square>
                <div>
                  <DataTable
                    columns={columns}
                    data={activedata}
                    progressPending={loading}
                    progressComponent={
                      <div style={{ height: "60vh" }}>
                        <Loader />
                      </div>
                    }
                    pagination
                    paginationServer
                    paginationTotalRows={totalActiveRows}
                    paginationPerPage={limitactive}
                    onChangeRowsPerPage={handlePerRowsActiveChange}
                    onChangePage={handlePageActiveChange}
                    currentPage={pageactive}
                    customStyles={queueDatatableCustomStyles}
                    selectableRowDisabled={isRowSelected}
                    selectableRows
                    onSelectedRowsChange={handleSelectChange}
                  />
                </div>
              </Paper>
            </Box>
          )}
          {filter == "inactive" && (
            <Box className="products-and-options" sx={{ mt: 1 }}>
              <Paper square>
                <div>
                  <DataTable
                    columns={columns}
                    data={inactivedata}
                    progressPending={loading}
                    progressComponent={
                      <div style={{ height: "60vh" }}>
                        <Loader />
                      </div>
                    }
                    pagination
                    paginationServer
                    paginationTotalRows={totalInActiveRows}
                    paginationPerPage={limitinactive}
                    onChangeRowsPerPage={handlePerRowsInactiveChange}
                    onChangePage={handlePageInactiveChange}
                    currentPage={pageinactive}
                    customStyles={queueDatatableCustomStyles}
                    selectableRowDisabled={isRowSelected}
                    selectableRows
                    onSelectedRowsChange={handleSelectChange}
                  />
                </div>
              </Paper>
            </Box>
          )}
        </div>
        {/* Image Modal Display */}
        <Modal
          show={showimg}
          onHide={handleCloseImage}
          centered
          className='modal_create'
        >
          <Modal.Header closeButton>
          </Modal.Header>
          <div className="promo_modal_img">
            <img src={promoimg} alt='' className="img-fluid" />
          </div>
        </Modal>
      </div>
    </>
  );
};

export default PromoCodes;